import { TextInput } from "@astryxdesign/core/TextInput";

interface Props {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  /** Message to show as an inline error, or null when the value is fine. */
  error: string | null;
}

/**
 * TextInput that takes `error: string | null` instead of an optional `status`.
 *
 * Astryx declares `status?: InputStatus` without `| undefined`, so under this repo's
 * `exactOptionalPropertyTypes` it cannot be spread conditionally. Doing the branch once
 * here keeps every caller to a single, honest prop.
 */
export function TextInputMaybeError({ label, placeholder, value, onChange, error }: Props) {
  if (error !== null) {
    return (
      <TextInput
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        status={{ type: "error", message: error }}
      />
    );
  }
  return (
    <TextInput
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  );
}
